import { render } from "./HeaderBody.vue?vue&type=template&id=4afd07b0"
import script from "./HeaderBody.vue?vue&type=script&lang=js"
export * from "./HeaderBody.vue?vue&type=script&lang=js"

import "./HeaderBody.vue?vue&type=style&index=0&id=4afd07b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__